// extracted by css-extract-rspack-plugin
export default {"field":"field-reBWEj"};